// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_container__y3W3e {
  padding: 0;
  /* margin-top : 4em; */
  position: relative;
}
.sidebar_main__1QyPX {
  width: 20em;
  position: fixed;
  background-color: #2d3436;
  top: 3em;
  bottom: 0;
  overflow-y: auto;
}

.sidebar_header__C8Hyf {
  display: flex;
  padding: 0.5em;
}

.sidebar_imgContainer__\\+57Zo {
  display: flex;
  padding: 0.5em;
}
.sidebar_imgContainer__\\+57Zo img {
  border-radius: 50%;
  border: 3px solid white;
  margin: auto;
}

.sidebar_hide__zJLye {
  margin-left: -16em;
  opacity: 0;
  transition-duration: 400ms;
}

.sidebar_show__G583J {
  margin-left: 0;
  opacity: 1;
  transition-duration: 400ms;
}
.sidebar_expand__3yF2o {
  right: 0em;
  transform: rotate(-180deg);
  transition-duration: 400ms;
}
.sidebar_collapse__WjTqI {
  right: -3em;
  transform: rotate(0deg);
  transition-duration: 400ms;
}
.sidebar_mainExpand__aRmH6 {
  margin-left: 0;
  transition-duration: 200ms;
}
.sidebar_mainCollapse__QzeGE {
  margin-left: -16em;
  transition-duration: 200ms;
}

.sidebar_listLink__J-CBp {
  display: flex;
  flex-direction: column;
}

.sidebar_listLink__J-CBp .sidebar_link__ZGTtl,
.sidebar_tempLink__UvTPm {
  padding: 0.5em 0.2em 0.5em 1em;
  text-align: start;
  display: flex;
  /* justify-content : space-between; */
  transition-duration: 100ms;
  color: white;
}
.sidebar_tempLink__UvTPm button {
  color: white;
  border: none;
  background: none;
}
.sidebar_listLink__J-CBp .sidebar_link__ZGTtl:hover {
  color: #ff7675;
  transition-duration: 200ms;
  padding-left: 1.5em;
}
.sidebar_link__ZGTtl a {
  color: white;
}
.sidebar_link__ZGTtl a:hover {
  color: #55efc4;
}

.sidebar_title__zNcYR {
  padding-top: 0.1em;
  padding-left: 0.5em;
  text-decoration: none;
  font-weight: 600;
  display: flex;
  width: 100%;
  font-size: 1.2em;
}
.sidebar_link__ZGTtl button {
  background: none;
  width: 100%;
  border: none;
  display: flex;
}

.sidebar_icon__yug0k {
  text-align: center;
  color: white;
  width: 30px;
}

.sidebar_active__oQFUh {
  color: #55efc4;
  /* border-left : .4em solid #00b894; */
  border-left: 0.4em solid #107d56;
}
.sidebar_active__oQFUh a {
  /* color : #55efc4; */
  color: #107d56;
}

.sidebar_inactive__Kvc2K {
  color: #222f3e;
}

.sidebar_buttonContainer__IcvCG {
  position: absolute;
  right: 0;
  justify-content: flex-end;
}
.sidebar_buttonContainer__IcvCG button {
  position: absolute;
  border: none;
  width: 2em;
  height: 2em;
  border-radius: 50%;
  margin: 0.5em 0.3em 0 0;
  background: #00cec9;
}

.sidebar_dropdownLinks__sKyVk {
  overflow: hidden;
  padding-left: 1.3em;
}

.sidebar_hidden__7nN0- {
  max-height: 0;
  margin-left: -2em;
  transition-duration: 300ms;
}

.sidebar_unhidden__wZVEP {
  max-height: unset;
  transition-duration: 300ms;
}

.sidebar_arrHidden__1gBV4 {
  transform: rotate(0);
  transition-duration: 300ms;
}

.sidebar_arrUnhidden__LIM8S {
  transform: rotate(90deg);
  transition-duration: 300ms;
}

.sidebar_footer__o35-X {
  color: white;
  text-align: start;
  padding-left: 0.5em;
  font-family: 'IBM Plex Sans', sans-serif;
  position: absolute;
  bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/sidebar.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;AACX","sourcesContent":[".container {\n  padding: 0;\n  /* margin-top : 4em; */\n  position: relative;\n}\n.main {\n  width: 20em;\n  position: fixed;\n  background-color: #2d3436;\n  top: 3em;\n  bottom: 0;\n  overflow-y: auto;\n}\n\n.header {\n  display: flex;\n  padding: 0.5em;\n}\n\n.imgContainer {\n  display: flex;\n  padding: 0.5em;\n}\n.imgContainer img {\n  border-radius: 50%;\n  border: 3px solid white;\n  margin: auto;\n}\n\n.hide {\n  margin-left: -16em;\n  opacity: 0;\n  transition-duration: 400ms;\n}\n\n.show {\n  margin-left: 0;\n  opacity: 1;\n  transition-duration: 400ms;\n}\n.expand {\n  right: 0em;\n  transform: rotate(-180deg);\n  transition-duration: 400ms;\n}\n.collapse {\n  right: -3em;\n  transform: rotate(0deg);\n  transition-duration: 400ms;\n}\n.mainExpand {\n  margin-left: 0;\n  transition-duration: 200ms;\n}\n.mainCollapse {\n  margin-left: -16em;\n  transition-duration: 200ms;\n}\n\n.listLink {\n  display: flex;\n  flex-direction: column;\n}\n\n.listLink .link,\n.tempLink {\n  padding: 0.5em 0.2em 0.5em 1em;\n  text-align: start;\n  display: flex;\n  /* justify-content : space-between; */\n  transition-duration: 100ms;\n  color: white;\n}\n.tempLink button {\n  color: white;\n  border: none;\n  background: none;\n}\n.listLink .link:hover {\n  color: #ff7675;\n  transition-duration: 200ms;\n  padding-left: 1.5em;\n}\n.link a {\n  color: white;\n}\n.link a:hover {\n  color: #55efc4;\n}\n\n.title {\n  padding-top: 0.1em;\n  padding-left: 0.5em;\n  text-decoration: none;\n  font-weight: 600;\n  display: flex;\n  width: 100%;\n  font-size: 1.2em;\n}\n.link button {\n  background: none;\n  width: 100%;\n  border: none;\n  display: flex;\n}\n\n.icon {\n  text-align: center;\n  color: white;\n  width: 30px;\n}\n\n.active {\n  color: #55efc4;\n  /* border-left : .4em solid #00b894; */\n  border-left: 0.4em solid #107d56;\n}\n.active a {\n  /* color : #55efc4; */\n  color: #107d56;\n}\n\n.inactive {\n  color: #222f3e;\n}\n\n.buttonContainer {\n  position: absolute;\n  right: 0;\n  justify-content: flex-end;\n}\n.buttonContainer button {\n  position: absolute;\n  border: none;\n  width: 2em;\n  height: 2em;\n  border-radius: 50%;\n  margin: 0.5em 0.3em 0 0;\n  background: #00cec9;\n}\n\n.dropdownLinks {\n  overflow: hidden;\n  padding-left: 1.3em;\n}\n\n.hidden {\n  max-height: 0;\n  margin-left: -2em;\n  transition-duration: 300ms;\n}\n\n.unhidden {\n  max-height: unset;\n  transition-duration: 300ms;\n}\n\n.arrHidden {\n  transform: rotate(0);\n  transition-duration: 300ms;\n}\n\n.arrUnhidden {\n  transform: rotate(90deg);\n  transition-duration: 300ms;\n}\n\n.footer {\n  color: white;\n  text-align: start;\n  padding-left: 0.5em;\n  font-family: 'IBM Plex Sans', sans-serif;\n  position: absolute;\n  bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `sidebar_container__y3W3e`,
	"main": `sidebar_main__1QyPX`,
	"header": `sidebar_header__C8Hyf`,
	"imgContainer": `sidebar_imgContainer__+57Zo`,
	"hide": `sidebar_hide__zJLye`,
	"show": `sidebar_show__G583J`,
	"expand": `sidebar_expand__3yF2o`,
	"collapse": `sidebar_collapse__WjTqI`,
	"mainExpand": `sidebar_mainExpand__aRmH6`,
	"mainCollapse": `sidebar_mainCollapse__QzeGE`,
	"listLink": `sidebar_listLink__J-CBp`,
	"link": `sidebar_link__ZGTtl`,
	"tempLink": `sidebar_tempLink__UvTPm`,
	"title": `sidebar_title__zNcYR`,
	"icon": `sidebar_icon__yug0k`,
	"active": `sidebar_active__oQFUh`,
	"inactive": `sidebar_inactive__Kvc2K`,
	"buttonContainer": `sidebar_buttonContainer__IcvCG`,
	"dropdownLinks": `sidebar_dropdownLinks__sKyVk`,
	"hidden": `sidebar_hidden__7nN0-`,
	"unhidden": `sidebar_unhidden__wZVEP`,
	"arrHidden": `sidebar_arrHidden__1gBV4`,
	"arrUnhidden": `sidebar_arrUnhidden__LIM8S`,
	"footer": `sidebar_footer__o35-X`
};
export default ___CSS_LOADER_EXPORT___;
